import {EntityWithIdAndDescription} from "./baseEntities";

export enum AmortizationSystemTypeFields {
    CondorId = 'vchIdCondor',
    LineCode = 'sinCodLinea'
}

export interface AmortizationType extends EntityWithIdAndDescription{
    [AmortizationSystemTypeFields.CondorId]: string;
    [AmortizationSystemTypeFields.LineCode]: number;
}

export enum OperationReasonDestinationFields {
    OperationDestinationCode = 'tinCodOperacionDestino'
}

export interface OperationReasonDestination extends EntityWithIdAndDescription {
    [OperationReasonDestinationFields.OperationDestinationCode]: number
}